/* import __COLOCATED_TEMPLATE__ from './section-header.hbs'; */
import templateOnly from '@ember/component/template-only';
import type { ContentValue } from '@glint/template';

export interface BvModalSectionHeaderSignature {
  Args: {
    title: ContentValue;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

const BvModalSectionHeaderComponent =
  templateOnly<BvModalSectionHeaderSignature>('BvModal::SectionHeader');

export default BvModalSectionHeaderComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvModal::SectionHeader': typeof BvModalSectionHeaderComponent;
    'bv-modal/section-header': typeof BvModalSectionHeaderComponent;
  }
}
